import { useState, useEffect } from "react";
import { getGalleryData } from "../api/dataSource";
import PageBanner from "../components/PageBanner";

export default function Gallery() {
  const [galleryImages, setGalleryImages] = useState([]);

  // Helper function to get correct image extension
  const getImageExtension = (id) => {
    const extensions = {
      1: '.webp', 2: '.webp', 3: '.webp', 4: '.webp',
      5: '.webp', 6: '.jpeg', 7: '.jpg', 8: '.webp'
    };
    return extensions[id] || '.jpg';
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await getGalleryData();
      setGalleryImages(data);
    };
    fetchData();
  }, []);

  return (
    <>
      <PageBanner
        title="Gallery"
        subtitle="Photos from our chess tournaments and events"
        image="/images/chess.png"
      />

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">

          {/* Heading */}
         

          {/* Gallery Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
            {galleryImages && galleryImages.length > 0 ? (
              galleryImages.map((image) => (
                <div
                  key={image.id}
                  className="group relative bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500"
                >
                  {/* Image */}
                  <img
                    src={image.image || `/images/g${((image.id - 1) % 8) + 1}${getImageExtension(((image.id - 1) % 8) + 1)}`}
                    alt={`Gallery ${image.id}`}
                    className="w-full h-56 object-cover group-hover:scale-110 transition-transform duration-700"
                    onError={(e) => {
                      // Try jpg first, then webp, then jpeg
                      const id = ((image.id - 1) % 8) + 1;
                      const extensions = ['.jpg', '.webp', '.jpeg'];
                      let tried = 0;
                      
                      const tryNextExtension = () => {
                        if (tried < extensions.length) {
                          e.currentTarget.src = `/images/g${id}${extensions[tried]}`;
                          tried++;
                        }
                      };
                      
                      tryNextExtension();
                    }}
                  />

                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition duration-500 flex items-center justify-center">
                    <span className="text-white font-semibold tracking-wide">
                      View Image
                    </span>
                  </div>

                  {/* Outline Accent */}
                  <div className="absolute inset-0 rounded-2xl ring-1 ring-gray-200 group-hover:ring-blue-400 transition"></div>
                </div>
              ))
            ) : (
              <div className="col-span-full text-center py-12">
                <p className="text-gray-500 text-lg">Loading gallery images...</p>
              </div>
            )}
          </div>

        </div>
      </section>
    </>
  );
}
